import { HStack, Text } from "@chakra-ui/react";
import React from "react";
import { renderInnerHtml } from "@/helpers/dom";

interface SummaryItemProps {
  label: string;
  value: string;
}

export const FormSummaryItem = ({ label, value }: SummaryItemProps) => {
  return (
    <HStack alignItems="flex-start">
      <Text
        flexShrink="0"
        fontWeight="bold"
      >
        {renderInnerHtml(label)}
      </Text>
      <Text>{value}</Text>
    </HStack>
  );
};
